/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2025-04-17T17:39:58.424
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import request from '@/plugins/request';

export function listReportMonthRentContractUndueInit(data){return request({
url: '/report/api/reportMonthRentContractUndue/listReportMonthRentContractUndueInit',
method: 'post',
data:data,
});
}


export function listReportMonthRentContractUndueByAuthorizations(data){return request({
url: '/report/api/reportMonthRentContractUndue/listReportMonthRentContractUndueByAuthorizations',
method: 'post',
data:data,
});
}


export function listReportMonthRentContractUndue(data){return request({
url: '/report/api/reportMonthRentContractUndue/listReportMonthRentContractUndue',
method: 'post',
data:data,
});
}


export function getReportMonthRentContractUndueCreateInit(){return request({
url: '/report/api/reportMonthRentContractUndue/getReportMonthRentContractUndueCreateInit',
method: 'post',
});
}


export function getReportMonthRentContractUndueEditInit(params){return request({
url: '/report/api/reportMonthRentContractUndue/getReportMonthRentContractUndueEditInit',
method: 'post',
params:params,
});
}


export function getReportMonthRentContractUndueView(params){return request({
url: '/report/api/reportMonthRentContractUndue/getReportMonthRentContractUndueView',
method: 'post',
params:params,
});
}


export function saveReportMonthRentContractUndue(data){return request({
url: '/report/api/reportMonthRentContractUndue/saveReportMonthRentContractUndue',
method: 'post',
data:data,
});
}


export function deleteReportMonthRentContractUndue(params){return request({
url: '/report/api/reportMonthRentContractUndue/deleteReportMonthRentContractUndue',
method: 'post',
params:params,
});
}


